@if (values != null) {
    <div class="row">
        <div class="col-6">
            @if ({ label: 'Title', type: 'string', locale: true, name: 'title' }; as field) {
                @if (!viewOnly) {
                    <app-pg-form-field [fieldData]="field" [languages]="availableLanguages" [(ngModel)]="values.title" (ngModelChange)="handleValuesChange();"></app-pg-form-field>
                }
                @if (viewOnly) {
                    <app-pg-detail-field [fieldData]="field" [value]="values.title"></app-pg-detail-field>
                }
            }
        </div>
        <div class="col-6">
            @if ({ label: 'Color', type: 'select', options: colorOptions, name: 'color' }; as field) {
                @if (!viewOnly) {
                    <app-pg-form-field [fieldData]="field" [(ngModel)]="values.color" (ngModelChange)="handleValuesChange();"></app-pg-form-field>
                }
                @if (viewOnly) {
                    <app-pg-detail-field [fieldData]="field" [value]="values.color"></app-pg-detail-field>
                }
            }
        </div>
        <div class="col-6">
            @if ({ label: 'Condition', type: 'select', options: conditionOptions, name: 'condition' }; as field) {
                @if (!viewOnly) {
                    <app-pg-form-field [fieldData]="field" [display]="conditionDisplay" [(ngModel)]="values.condition" (ngModelChange)="handleValuesChange();"></app-pg-form-field>
                }
                @if (viewOnly) {
                    <app-pg-detail-field [fieldData]="field" [value]="values.condition"></app-pg-detail-field>
                }
            }
        </div>
    </div>
    <hr>
    @if (widgetFields[values.name] != null) {
        <div class="row">
            @for (field of widgetFields[values.name]; track field) {
                <div class="{{field.type == 'html' || field.type == 'location' ? 'col-12' : 'col-6'}}">
                    @if (!viewOnly) {
                        <app-pg-form-field [fieldData]="field" [languages]="availableLanguages" [ngModel]="getParamField(field.name)" (ngModelChange)="setParamField(field.name, $event); handleValuesChange();"></app-pg-form-field>
                    }
                    @if (viewOnly) {
                        <app-pg-detail-field [fieldData]="field" [ngModel]="getParamField(field.name)"></app-pg-detail-field>
                    }
                </div>
            }
        </div>
    }
    @if (widgetFields[values.name] == null) {
        <div class="row">
            <div class="col-12">
                @if ({ label: 'Parameters', type: 'json', name: 'params' }; as field) {
                    @if (!viewOnly) {
                        <app-pg-form-field [fieldData]="field" [ngModel]="JSONStringify(values.params)" (ngModelChange)="values.params = JSONParse($event); handleValuesChange();"></app-pg-form-field>
                    }
                    @if (viewOnly) {
                        <app-pg-detail-field [fieldData]="field" [value]="JSONStringify(values.params)"></app-pg-detail-field>
                    }
                }
            </div>
        </div>
    }
}